export default __webpack_public_path__ + "static/media/Centaurus.7f293ae0.png";